module.exports = __webpack_public_path__ + "media/images/lj-5b09326a83a8f3f8bc91b0d3c5f3984e.png";